import React, { createContext, useState, useContext, useEffect } from "react";
import { LocalStorageService } from "service/LocalStorageService";
import { LoginService } from "service/LoginService";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const lsService = new LocalStorageService();
  const loginService = new LoginService();

  useEffect(() => {
    const savedUser = lsService.getUserLogin();
    if (savedUser) {
      setUser(savedUser);
    }
    setLoading(false);
  }, []);

  const login = async (credentials) => {
    try {
      const res = await loginService.logIn(credentials);
      if (res && res.token) {
        lsService.setToken(res);
        const rol = lsService.getRolFromToken();
        if (rol === 'Alumno') {
          lsService.clearToken();
          return { success: false, message: "Acceso no permitido. Esta plataforma es solo para administradores." };
        }
        setUser(res);
        return { success: true };
      }
      return { success: false, message: res?.message || "Credenciales inválidas" };
    } catch (error) {
      return { success: false, message: "Error de conexión con el servidor" };
    }
  };

  const logout = async () => {
    try {
      await loginService.cerrarSesion();
    } catch (error) {
      console.error("Error closing session on server", error);
    } finally {
      lsService.clearToken();
      setUser(null);
      window.location.href = "/admin/login";
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, isAuthenticated: !!user }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
